const PLAN_CODE_ALPHABET =
  'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

function formatPlanCodeDatePrefix(date = new Date()): string {
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = String(date.getFullYear());
  return `${day}-${month}-${year}`;
}

/** Frontend-only plan code: `DD-MM-YYYY-` + random letters/digits. */
export function generatePlanCode(length = 20): string {
  const bytes = new Uint8Array(length);
  crypto.getRandomValues(bytes);
  let code = '';
  for (let i = 0; i < length; i += 1) {
    code += PLAN_CODE_ALPHABET[bytes[i]! % PLAN_CODE_ALPHABET.length];
  }
  return `${formatPlanCodeDatePrefix()}-${code}`;
}
